/**************************************************
 * Nombre:       Seccion_Contenido_Caps
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CONTAR_ARR,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO,
    CASILLA_IMG,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {AssignmentTurnedInOutlined, ManageSearch} from "@mui/icons-material";
import {ESTADOSUSUARIOS} from "../../Constantes";
import Dialogo_Contenido_Caps from "../Dialogos/ContenidoCaps/Dialogo_Contenido_Caps";
import Dialogo_Contenido_Test from "../Dialogos/ContenidoCaps/Dialogo_Contenido_Test";


const Seccion_Contenido_Caps = () => {
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025({coleccion: 'contenidos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Contenido_Caps,
        titulo: 'Detalles del Contenido',
        realizado: cargarNuevamente
    })
    const {Dialogo:DialogoTest, abrir:abrirTest} = useDialogo({
        Componente: Dialogo_Contenido_Test,
        titulo: 'Test de Capacitacion',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break;
            case 'test':
                abrirTest(data)
                break;
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoTest/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de Contenido'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Contenido_Caps

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO

    },
    {
        nombre: 'Contenidos',
        direccion: 'right',
        propiedad: 'contenidos',
        tipo: CASILLA_CONTAR_ARR

    },
    {
        nombre: 'Preguntas',
        direccion: 'right',
        propiedad: 'preguntas',
        tipo: CASILLA_CONTAR_ARR

    }

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },{
        nombre: 'Test',
        id: 'test',
        icono: AssignmentTurnedInOutlined
    },
]